module.exports = __webpack_public_path__ + "static/thomas-uta-avatar-500px-lowres-21d5fc79ab0db2e40e12c3e957a6b3ce.jpg";